import { ShareImageDialog } from "@/components/BadgeShare";
import { renderPostImage } from "@/lib/postImage";
import { renderPollImage } from "@/lib/pollImage";
import { imgSrc } from "@/lib/api";

export function PostShare({ post, user, onClose }) {
  const link = `${window.location.origin}/registrieren?ref=${user.referral_code}`;
  const text = post.text || post.video?.title || "";
  const photo = post.images?.[0] ? imgSrc(post.images[0]) : post.video?.thumbnail;
  const p = { ...post, text, picture: post.picture ? imgSrc(post.picture) : null };
  return (
    <ShareImageDialog prefix="post" title="In Story teilen" alt={`Beitrag von ${post.name}`} fileBase={`itzcouple-beitrag-${post.id.slice(0, 8)}`} onClose={onClose}
      description={post.poll ? "Teile das Umfrage-Ergebnis als Bild in deiner Instagram- oder TikTok-Story. Dein Einladungscode ist mit drauf." : "Teile diesen Beitrag als Bild in deiner Instagram- oder TikTok-Story. Dein Einladungscode ist mit drauf."}
      msg={`Schau dir diesen Beitrag in der itzPlay Community an 💖 ${window.location.origin}/post/${post.id}`}
      render={(format) => (post.poll ? renderPollImage({ post: p, code: user.referral_code, format }) : renderPostImage({ post: p, photo, code: user.referral_code, format }))} deps={[post.id, link, post.poll?.total]} />
  );
}
